<template lang="pug">
 div
  // Header
  .header.bg-gradient-indigo.py-3.py-lg-4.pt-lg-9
    b-container
      .header-body.text-center.mb-7
        b-row.justify-content-center
          b-col.px-5(xl='5' lg='6' md='8')
            h1.text-white.mb-3 Willkommen zu doQument

  
           

  // Page content
 

  b-container.mt--8.pb-5
    b-row.justify-content-center
    
      b-col(lg='5' md='7')
       b-overlay(:show="linked_loading")  
        b-card.bg-secondary.border-0.mb-0(no-body='')
          b-card-header.bg-transparent.pb-5
            .text-muted.text-center.mt-2.mb-3
             
             
              small Sign in mit
            .btn-wrapper.text-center
              //a.btn.btn-neutral.btn-icon(href='#')
                span.btn-inner--icon
                  img(src='img/icons/common/github.svg')
                span.btn-inner--text Github
           
              b-btn.btn.btn-neutral.btn-icon(@click="signInMS()")
                span.btn-inner--icon
                  i.fab.fa-microsoft
                span.btn-inner--text Microsoft
          //b-card-body.px-lg-5.py-lg-5
            .text-center.text-muted.mb-4
              small Sign in with credentials
            validation-observer(v-slot='{handleSubmit}' ref='formValidator')
              b-form(role='form' @submit.prevent='handleSubmit(login)')
                base-input.mb-3(alternative='' type="email" name='Email' :rules='{required: true, email: true}' prepend-icon='ni ni-email-83' placeholder='Email' v-model='model.email')
                base-input.mb-3(alternative='' name='Password' :rules='{required: true, min: 6}' prepend-icon='ni ni-lock-circle-open' type='password' placeholder='Password' v-model='model.password')
                //b-form-checkbox(v-model='model.rememberMe') Remember me
                .text-center
                  base-button.my-4(type='primary' native-type='submit') Sign in
        //b-row.mt-3
          b-col(cols='6')
            router-link.text-light(to='/dashboard')
              small Forgot password?
          b-col.text-right(cols='6')
            router-link.text-light(to='/register')
              small Create new account

</template>
<script>
import Vue from 'vue';

  export default {
    data() {
      return {
        linked_loading: false,
        
        model: {
          email: '',
          password: '',
         
          rememberMe: false,
          csfr_response: null,
          showDismissibleAlert: false
        }
      };
    },

    mounted() {
      this.getData();

     
    },
    computed: {
      loc() {
        return "https://" + window.location.host + "/users/login";
      }
    },
    methods: {

    login() {
      this.showDismissibleAlert = false;
    
      this.axios.post(this.base_url+'/users/login', {email: this.model.email, password: this.model.password}, {headers: {"X-XSRF-Token": this.csfr_response.access_token}}).then((res) => {
          console.log(res);

          if(res && res.status == 200) {
            localStorage['auth'] = "diie93992i";
            
            Vue.axios.get(`${Vue.prototype.base_url}/users/me`).then(res => {
              if(res) Vue.prototype.$auth = res.data;
            });

            this.$router.push({ path: (this.$route.query.next || "dashboard") });
          } else if(res && res.status == 429) {
            alert(res.data.detail.error_msg);
          } else {
            alert("Invalid credentials");
          }

      }, (res) => {
       
        console.log("error",res);
        if(res.status == 429) {
          alert(res.data.detail.error_msg);
        } else {
          alert("Invalid credentials");
        }
        
        
        this.showDismissibleAlert = true;
      });

    },

    confirmOAuthMS(code) {
      
      return this.axios.get(this.base_url+'/microsoft_redirect', {
        params: { code, redirect_uri: this.loc },
      }).then((resp) => {
          localStorage['auth'] = "diie93992i";
          if(resp) Vue.prototype.$auth = resp.data;

          this.$router.push({ path: ("/dashboard") });
          return resp.data;
      });
    },

    signInMS() {
         return this.axios.get(this.base_url+'/microsoft_login_server', {
           params: { redirect_uri: this.loc },
         }).then((resp) => {
        
          location.href = resp.data;
      });
    },


    getData() {
        return this.axios.get(this.base_url+'/csfr_token').then((resp) => {
          this.csfr_response = resp.data;
         
          if(this.$route.query.code) {
            this.confirmOAuthMS(this.$route.query.code);
          }
        });
    },

    }
  };
</script>
